export default {
  en: {
    'pages.data-formats.title': 'Data Formats',
    'pages.data-formats.no-results.title': 'No results',
    'pages.data-formats.no-results.description': 'No jurisdictions with data formats found',
    'pages.data-formats.update.error': 'Error updating data formats. Please try again.',
    'pages.data-formats.list.error': 'Error loading data formats. Please try again.',
  },
};
